<template>
  <modal @leave="$emit('leave')" show-close-btn width="600px">
    <div class="mb-6" v-if="countryKey">
      <label>Country:</label>
      <select v-model="address[countryKey]" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
        <option value="AU">Australia</option>
        <option value="BB">Barbados</option>
        <option value="CY">Cyprus</option>
        <option value="FR">France</option>
        <option value="DE">Germany</option>
        <option value="HU">Hungary</option>
        <option value="IE">Ireland</option>
        <option value="JE">Jersey</option>
        <option value="MU">Mauritius</option>
        <option value="NA">Namibia</option>
        <option value="PT">Portugal</option>
        <option value="ZA">South Africa</option>
        <option value="ES">Spain</option>
        <option value="CH">Switzerland</option>
        <option value="TH">Thailand</option>
        <option value="AE">UAE</option>
        <option value="GB">United Kingdom</option>
        <option value="ZW">Zimbabwe</option>
      </select>
    </div>

    <div class="flex flex-wrap -mx-2 mb-6" v-if="!countryKey || (countryKey && address[countryKey] === 'GB')">
      <div class="w-full md:w-1/4 px-2">
        <label for="lookup_postcode">Post Code:</label>
        <input type="text" v-model="address[postcodeKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3 uppercase" maxlength="8" />
      </div>

      <div class="w-full md:w-3/4 px-2">
        <label for="lookup_postcode">Address:</label>
        <loader v-if="searching" />
        <select v-else v-model="selectedSuggestion" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3">
          <option :value="null">[Please Select]</option>
          <option v-for="(suggestion, i) in suggestions" :key="i" :value="suggestion.data">
            {{ suggestion.formatted }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="!manualOpen && !address[nameNumberKey] && (!countryKey || (countryKey && address[countryKey] === 'GB'))" class="text-center underline text-blue hover:text-blue-dark text-xs cursor-pointer" @click="manualOpen = true">
      [+] Enter Manually
    </div>
    <div v-else>
      <div v-if="nameKey" class="mb-6">
        <label>Recipient Name:</label>
        <input type="text" v-model="address[nameKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
      <div class="flex flex-wrap -mx-2">
        <div class="w-full md:w-1/2 px-2 mb-6">
          <label>Line 1:</label>
          <input type="text" v-model="address[nameNumberKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
        </div>
        <div class="w-full md:w-1/2 px-2 mb-6">
          <label>Line 2:</label>
          <input type="text" v-model="address[streetKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
        </div>
      </div>
      <div class="mb-6">
        <label>Line 3:</label>
        <input type="text" v-model="address[line3Key]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
      <div class="mb-6">
        <label>Town:</label>
        <input type="text" v-model="address[townKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
      <div class="mb-6">
        <label>County:</label>
        <input type="text" v-model="address[countyKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
      <div class="mb-6" v-if="!countryKey || (countryKey && address[countryKey] !== 'GB')">
        <label>Post Code:</label>
        <input type="text" v-model="address[postcodeKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
    </div>

    <div class="flex justify-end">
      <button @click="$emit('leave')" class="bg-primary rounded py-3 px-12 text-white">
        Save
      </button>
    </div>
  </modal>
</template>

<script>
import api from '@/http'
import debounce from 'lodash/debounce'
export default {
  props: {
    value: Object,
    nameKey: {
      type: String,
      default: null
    },
    nameNumberKey: {
      type: String,
      default: 'address_name_number'
    },
    streetKey: {
      type: String,
      default: 'address_line2'
    },
    line3Key: {
      type: String,
      default: 'address_line3'
    },
    townKey: {
      type: String,
      default: 'address_town'
    },
    countyKey: {
      type: String,
      default: 'address_line4'
    },
    countryKey: {
      type: String,
      default: null
    },
    postcodeKey: {
      type: String,
      default: 'address_postcode'
    },
    thoroughfareKey: {
      type: String,
      default: 'address_thoroughfare'
    }
  },
  data () {
    return {
      address: this.value,
      suggestions: [],
      selectedSuggestion: null,
      manualOpen: false,
      searching: false
    }
  },
  watch: {
    address: {
      handler () {
        this.$emit('input', this.address)
        this.search()
      },
      deep: true
    },
    selectedSuggestion (suggestion) {
      if (!suggestion) {
        return
      }

      this.address[this.nameNumberKey] = suggestion.address_name_number
      this.address[this.streetKey] = suggestion.address_line2
      this.address[this.line3Key] = suggestion.address_line3
      this.address[this.townKey] = suggestion.address_town
      this.address[this.countyKey] = suggestion.address_line4
      this.address[this.postcodeKey] = suggestion.address_postcode
      this.address[this.thoroughfareKey] = suggestion.address_thoroughfare
    }
  },
  created () {
    this.search()
  },
  methods: {
    search: debounce(function () {
      if (!RegExp('^[A-PR-UWYZ][A-HJ-Y]?[0-9][0-9A-HJKMNPR-Y]? ?[0-9][ABD-HJLNP-UW-Z]{2}$', 'gi').test(this.address[this.postcodeKey])) {
        return
      }

      this.selectedSuggestion = null
      this.searching = true
      api.get('/address-lookup', {
        params: {
          postcode: this.address[this.postcodeKey]
        }
      }).then((response) => {
        this.suggestions = response.data
        this.searching = false
      }, () => {
        this.searching = false
      })
    }, 500)
  }
}
</script>
